import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"

const useTradingCompanies = ({ query }: { query: string }) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading_companies", { query: query }],
    () => scientApi.trading.getTradingCompanies({ query: query }),
    {
      retry: 1,
      staleTime: Infinity, // Static list, no need to refresh.
      enabled: query.length >= 2, // Only fetch when query length is >= 2
    },
  )

  return {
    companies: data,
    error: error as AxiosError,
    isLoading,
  }
}

export default useTradingCompanies
